<template>
  <div class="General">
    <div class="carroselCtn">
      <div class="StatementOnAccount">
        <label
          v-for="item in tabs"
          :key="item.text"
          class="StatementOnAccountItem"
          :class="{ active: selectedTabLabel === item.value }"
          @click="storeLabelTabName(item.text)"
        >
          {{ item.text }} <br />
        </label>
      </div>
    </div>

    <div class="ContainerMove" v-if="selectedTabLabel === 'Movimentações'">
      <div class="ContainerBtn">
        <b-button class="BtnRegister" @click="modalHeight">
          <b-icon-plus
            scale="1.5"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-plus>
          <span style="width: 170px">Nova Movimentação</span>
        </b-button>
      </div>

      <div class="ContainerSearchInput">
        <div class="textRegister">
          <span>Movimentações Registradas</span>
        </div>

        <div class="searchContainer">
          <div class="searchInput">
            <button class="btnPeriod" size="sm">Período</button>
            <div class="dateInput">
              <input
                type="date"
                id="dateStart"
                v-model="startDate"
                style="padding: 0.25rem 0.25rem 0.25rem 0.5rem; width: 130px"
                @change="search(false)"
              />
              <input
                type="date"
                id="dateEnd"
                v-model="endDate"
                style="padding: 0.25rem 1rem 0.25rem 0.25rem; width: 140px"
                @change="search(false)"
              />
            </div>
          </div>

          <div class="searchInput">
            <b-form-select
              class="searchFilter"
              size="sm"
              value-field="value"
              text-field="text"
              v-model="typeMov"
              :options="movTypeCombobox"
              @change="search(false)"
              style="border-radius: 5px 0 0 5px"
            />

            <b-form-select
              class="searchFilter"
              size="sm"
              value-field="value"
              text-field="text"
              v-model="filterField"
              :options="filterCombobox"
              style="border-radius: 0 !important; border-left: none"
            ></b-form-select>

            <b-input
              size="sm"
              class="inputSearch"
              v-model="filterValue"
              @keyup.enter="addFilter"
            ></b-input>

            <button @click="addFilter" size="sm" class="searchBtn">
              <b-icon-plus font-scale="1.8"></b-icon-plus>
            </button>

            <button
              class="searchAll"
              @click="search(true)"
              v-b-tooltip.hover.top="'Atualizar / Limpar'"
            >
              <b-icon-arrow-counterclockwise scale="1.3" />
            </button>
          </div>
        </div>
      </div>

      <div
        class="activeFiltersContainer"
        v-if="Object.keys(appliedfilters).length > 0"
      >
        <span
          v-for="(key, index) in Object.keys(appliedfilters)"
          :key="index"
          class="filterChip"
        >
          <strong>{{ compareteFilters[key] }}:</strong>
          {{ appliedfilters[key] }}

          <b-icon-x class="removeIcon" @click="removeFilter(key)"></b-icon-x>
        </span>
        <span class="clearAllTags" @click="clearSearch(true)">Limpar</span>
      </div>
      <div class="generalContainer">
        <div class="rowProvisionService">
          <div class="ContentTable">
            <div class="headerTable">
              <div
                class="celTable"
                style="
                  width: 10%;
                  cursor: pointer;
                  display: flex;
                  flex-direction: row;
                  gap: 0.3rem;
                  justify-content: center;
                  align-items: center;
                "
                @click="toggleTypeOrdered('date')"
              >
                <p style="margin: 0">Data</p>
                <b-icon-funnel-fill v-if="typeOrdered === 'date'" />
                <b-icon-funnel v-else />
              </div>
              <div
                class="celTable"
                style="
                  width: 10%;
                  cursor: pointer;
                  display: flex;
                  flex-direction: row;
                  gap: 0.3rem;
                  justify-content: center;
                  align-items: center;
                "
                @click="toggleTypeOrdered('createdAt')"
              >
                <p style="margin: 0">Data Criação</p>
                <b-icon-funnel-fill v-if="typeOrdered === 'createdAt'" />
                <b-icon-funnel v-else />
              </div>
              <div class="celTable" style="width: 20%">Agrotóxico</div>
              <div class="celTable" style="width: 5%">Qnt.</div>
              <div class="celTable" style="width: 25%">Embalagem</div>
              <div class="celTable" style="width: 10%">N°</div>
              <div class="celTable" style="width: 10%">Lote</div>
              <div class="celTable" style="width: 10%">N° NF-e</div>
              <div class="celTable" style="width: 8%">Origem</div>
              <div class="celTableActions">Ações</div>
            </div>

            <div
              v-for="moviment in moviments"
              :key="moviment.id"
              class="rowSupplier"
              @click.stop="edit(moviment.id)"
            >
              <div class="celTable" style="width: 10%">
                {{ moviment.data | moment }}
              </div>
              <div class="celTable" style="width: 10%">
                {{ moviment.createdAt | moment }}
              </div>
              <div class="celTable" style="width: 20%">
                {{ moviment.nomeProduto }}
              </div>
              <div class="celTable" style="width: 5%">
                {{ moviment.quantidade || "--" }}
              </div>
              <div class="celTable" style="width: 25%">
                <p
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin: 0;
                  "
                >
                  {{
                    `${moviment.embalagem.substr(0, 50)}${
                      moviment.embalagem.length > 50 ? "..." : ""
                    }` || "--"
                  }}
                </p>
              </div>
              <div class="celTable" style="width: 10%">
                {{ moviment.receita || "--" }}
              </div>
              <div class="celTable" style="width: 10%">
                {{ moviment.lote || "--" }}
              </div>
              <div class="celTable" style="width: 10%">
                {{ moviment.numeroNfe || "--" }}
              </div>
              <div class="celTable" style="width: 8%">
                {{ showTypeMov(moviment.tipo) }} -
                {{
                  moviment.idVenda
                    ? "Venda"
                    : moviment.idCompra
                    ? "Compra"
                    : "Manual"
                }}
              </div>

              <div class="celTableActions">
                <span
                  class="celInfos"
                  v-b-tooltip.hover.top="'Excluir'"
                  @click.stop="handleOpenModalDelete(moviment.id)"
                  ><b-icon-trash-fill scale="1.5"
                /></span>

                <div
                  v-if="
                    ['ES', 'MT', 'SC'].includes(getCompanyUf)
                  "
                >
                  <div v-if="reportSedding.id === moviment.id">
                    <span style="padding-left: 10px; padding-right: 4px"
                      ><b-spinner small
                    /></span>
                  </div>

                  <div v-else>
                    <span
                      class="celInfos"
                      v-b-tooltip.hover.top="'Enviar movimentação'"
                      v-if="Boolean(moviment.isReportSended) === false"
                      @click.stop="handleSendReport(moviment.id, false)"
                      ><b-icon-cursor scale="1.5"
                    /></span>

                    <span
                      class="celInfos"
                      v-b-tooltip.hover.top="'Cancelar movimentação'"
                      v-if="Boolean(moviment.isReportSended) === true"
                      @click.stop="handleSendReport(moviment.id, true)"
                      ><b-icon-x-lg scale="1.5"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="FooterPagination">
        <div class="setBtn">
          <button
            class="itemBtn"
            :disabled="page == 1"
            @click="previousPage(page)"
          >
            <b-icon-chevron-left></b-icon-chevron-left>
          </button>

          <button class="centerItemBtn">{{ page }}</button>

          <button
            class="itemBtn"
            :disabled="this.dataLength < 9"
            @click="nextPage(page)"
          >
            <b-icon-chevron-right></b-icon-chevron-right>
          </button>
        </div>
      </div>
      <div :class="sizeModal">
        <div :class="modalContainer" v-if="colapseModal">
          <b-button class="closeModalPurchase" @click="modalHeight">
            X
          </b-button>
          <Inventory style="margin-top: 30px" />
        </div>
      </div>
    </div>

    <div class="ContainerMove" v-if="selectedTabLabel === 'Inventário'">
      <Stock />
    </div>

    <ModalConfirm
      modalName="modal-confirm-moviment-pesticides"
      title="Deseja excluir esta movimentação?"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="deleteMoviment"
      leftButtonText="Não, obrigado!"
      rightButtonText="Sim, quero excluir!"
    />
    <div
      class="ContainerMove mt-3"
      v-if="selectedTabLabel === 'Inventário Geral'"
    >
      <StockGeral />
    </div>

    <ModalConfirm
      typeModal="info"
      modalName="alert-modal-reports"
      title="Erro ao enviar movimentação"
      subtitle="Identificamos que ocorreu um problema ao enviar essa movimentação para o órgão do estado"
      headerIcon="b-icon-patch-exclamation-fill"
      leftButtonText="Fechar"
      :showRightButton="false"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          border-radius: 5px;
          padding: 0.5rem 0 1rem 0;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0.5rem 1.2rem 0 1.2rem;
          "
        >
          <div style="display: flex; gap: 0.6rem; align-items: center">
            <div class="contentNewAlertIcon">
              <b-icon-info-circle style="color: red" scale="0.9" />
            </div>

            <p
              style="
                margin: 0 0 0 0;
                font-size: 0.8rem;
                font-family: Poppins-Bold, sans-serif !important;
              "
            >
              Corrija os erros abaixo!
            </p>
          </div>

          <p
            style="
              margin: 0;
              background-color: rgb(255 0 0 / 12%);
              border-radius: 50px;
              padding: 0.15rem 0.8rem;
              font-size: 0.65rem;
              color: brown;
            "
          >
            {{
              reportErrors.length === 1
                ? `${reportErrors.length} Erro`
                : `${reportErrors.length} Erros`
            }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 0.8rem;
            overflow: auto;
            width: 100%;
            max-height: 200px;
            padding: 0.2rem 1.2rem 0.6rem 1.2rem;
          "
        >
          <div
            v-for="(errors, idx) in reportErrors"
            :key="idx"
            class="contentReportError"
          >
            <div
              style="
                min-width: 23px;
                min-height: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgb(255 0 0 / 12%);
                border-radius: 50%;
                font-size: 0.68rem;
                color: brown;
              "
            >
              {{ idx + 1 }}
            </div>

            <p
              style="
                margin: 0;
                font-size: 0.75rem;
                color: oklch(44.6% 0.03 256.802);
                font-family: Poppins-Medium, sans-serif !important;
              "
            >
              {{ errors }}
            </p>
          </div>
        </div>
      </div>
    </ModalConfirm>
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import { DateTime } from "luxon";

import Inventory from "./Inventory.vue";
import Stock from "../../components/Stock/Stock.vue";
import StockGeral from "../../components/StockGeral/index.vue";

import { HandleErrors } from "../../utils/handleErrors";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import serviceMovimentPesticides from "../../services/serviceMovimentPesticides";
import axios from "axios";

export default {
  components: {
    Inventory,
    Stock,
    ModalConfirm,
    StockGeral,
  },
  data() {
    return {
      listEmpresas: [],
      month: DateTime.local(),
      filterField: "agrotoxico",
      filterValue: "",
      compareteFilters: {
        quantidade: "Quantidade",
        agrotoxico: "Agrotóxico",
        numeroNfe: "Nº NF-e",
        registroAgrotoxico: "Nº Registro",
        lote: "Nº Lote",
        receita: "Nº Receita",
      },
      appliedfilters: {},
      typeMov: "",
      startDate: "",
      endDate: "",
      colapseModal: false,
      spinDelete: false,
      modalContainer: "contentModalDisable",
      page: 1,
      dataLength: 0,
      sumPurchase: 0,
      countProducts: 0,
      moviments: [],
      dataSumPurchase: {},
      idFromDelete: "",
      filterCombobox: [
        { value: "agrotoxico", text: "Agrotóxico" },
        { value: "quantidade", text: "Quantidade" },
        { value: "numeroNfe", text: "Nº NF-e" },
        { value: "registroAgrotoxico", text: "Nº Registro" },
        { value: "lote", text: "Nº Lote" },
        { value: "receita", text: "Nº Receita" },
        { value: "codigo", text: "Código" },
      ],
      movTypeCombobox: [
        { value: "", text: "Todos" },
        { value: "Compra", text: "Compra" },
        { value: "Entrada", text: "Entrada" },
        { value: "Inventario Entrada", text: "Inventario Entrada" },
        { value: "Transferência Entrada", text: "Transferência Entrada" },
        { value: "Devolução", text: "Devolução Saida" },
        { value: "Devolução Entrada", text: "Devolução Entrada" },
        { value: "Inventario Saida", text: "Inventario Saida" },
        { value: "Transferência Saida", text: "Transferência Saida" },
        { value: "Venda", text: "Venda" },
      ],
      selectedTabLabel: "Movimentações",
      tabs: [
        { value: "Movimentações", text: "Movimentações" },
        { value: "Inventário", text: "Inventário" },
      ],
      typeOrdered: "date",
      reportSedding: false,
      reportErrors: [],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES",
    ]),
    addFilter() {
      if (!this.filterField || !this.filterValue.trim()) return;

      this.$set(this.appliedfilters, this.filterField, this.filterValue);

      this.filterValue = "";
      this.search();
    },

    removeFilter(key) {
      this.$delete(this.appliedfilters, key);
      this.search();
    },

    clearSearch(fullReset = false) {
      this.appliedfilters = {};
      this.filterValue = "";
      this.page = 1;

      if (fullReset) {
        this.startDate = "";
        this.endDate = "";
        this.typeMov = "";
      }

      this.search();
    },
    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
    },
    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");

      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES({});
        await this.search();
      }
    },

    async handleSendReport(id, isCancel = false) {
      try {
        this.reportSedding = {
          id: id,
          enviando: true,
        };

        if (isCancel) {
          await serviceMovimentPesticides.cancelReport(id);
        } else {
          await serviceMovimentPesticides.sendReport(id);
        }

        this.$toast.open({
          message: isCancel
            ? "Relatório cancelado com sucesso!"
            : "Relatório enviado com sucesso!",
          type: "info",
        });
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = msg;
        }
      } finally {
        this.reportSedding = {
          id: null,
          enviando: false,
        };

        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    showTypeMov(value) {
      const typeStockMoviments = {
        Compra: "E",
        Entrada: "E",
        "Inventario Entrada": "E",
        "Transferência Entrada": "E",
        "Devolução Entrada": "E",
        Devolução: "S",
        "Inventario Saida": "S",
        "Transferência Saida": "S",
        Venda: "S",
      };

      return typeStockMoviments[value];
    },

    async search(reset = false) {
      try {
        if (reset === true) {
          this.clearSearch(true);
        }

        this.moviments = await serviceMovimentPesticides.search(
          this.appliedfilters,
          this.typeMov,
          this.page,
          this.startDate,
          this.endDate,
          this.typeOrdered
        );

        this.dataLength = this.moviments.length;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar as movimentações",
          type: "info",
        });
      }
    },

    async edit(id) {
      try {
        const movimentPerticide = await serviceMovimentPesticides.findById(id);
        this.handleEditPurchase(movimentPerticide);
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      }
    },

    async deleteMoviment() {
      try {
        this.spinDelete = true;

        await serviceMovimentPesticides.delete(this.idFromDelete);

        await this.search();

        this.handleCloseModalDelete();

        this.$toast.open({
          message: "Movimentação removida!",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      } finally {
        this.spinDelete = false;
      }
    },

    handleEditPurchase(movimentPerticide) {
      this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES(movimentPerticide);
      this.modalHeight();
    },

    handleOpenModalDelete(movId) {
      this.idFromDelete = movId;
      this.openModals("modal-confirm-moviment-pesticides");
    },

    handleCloseModalDelete() {
      this.idFromDelete = "";
      this.closeModals("modal-confirm-moviment-pesticides");
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    closeModals(name) {
      this.$bvModal.hide(name);
    },

    toggleTypeOrdered(value) {
      if (this.typeOrdered === value) return;

      this.typeOrdered = value;
      this.search();
    },
    nextPage() {
      this.search((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.search((this.page -= 1));
      }
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      dataCompany: (state) => state.dataCompany,
    }),

    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },

    getCompanyUf() {
      return this.dataCompany?.uf?.toUpperCase() || "";
    },
  },
  async created() {
    this.search();
    this.ALTER_SIZE_MODAL("disable");
    this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES({});

    const userLevel = localStorage.getItem("userLevel");

    if (["adm", "corporate"].includes(userLevel)) {
      this.tabs.push({ value: "Inventário Geral", text: "Inventário Geral" });
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES({});
  },
};
</script>
<style scoped>
.activeFiltersContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 0 10px 0;
  background-color: transparent;
}

.filterChip {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: #006256;
  box-shadow: 0 0 0 1px #00625645;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 11px;
  animation: fadeIn 0.3s ease;
}

.removeIcon {
  cursor: pointer;
  font-size: 16px;
  color: #006256;
  transition: color 0.2s;
}

.removeIcon:hover {
  color: #c11010;
}

.clearAllTags {
  font-size: 11px;
  color: #c11010;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 5px;
}

.clearAllTags:hover {
  color: #8c0c0c;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.General {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
}

.carroselCtn {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 61px;
  width: 100%;
  height: 45px;
  min-height: 45px;
  background: #ffffff;
  border-radius: 3px;
}

.StatementOnAccount {
  display: flex;
  align-items: center;
  height: 35px;
  min-height: 35px;
  width: 100%;
  gap: 10px;
}

.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  padding: 0 10px;
  color: #006458;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  color: #006458;
  border-bottom: 3px solid #006458;
}

.StatementOnAccountItem:hover {
  background-color: #eaeaea;
  color: #006458;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.ContainerBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
}

.Btn {
  position: absolute;
  right: 40px;
  top: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background: whitesmoke;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
}

.lineSearch {
  display: flex;
  align-items: center;
  padding: 0px 0px 5px 0px;
}

.searchByMonth {
  width: 30%;
  display: flex;
  align-items: center;
  border-radius: 5px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.searchMonth {
  width: 100px;
  height: 30px;
  border-radius: 5px 0px 0px 5px;
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchMonth:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchYear {
  width: 50px;
  height: 30px;
  border-radius: 0px 5px 5px 0px;
  border: 1px solid rgb(195, 193, 193);
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchYear:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select3 {
  left: 4px;
  -moz-appearance: none;
  appearance: none;
  background: none;
  font-weight: bold;
  padding: 0 !important;
}

.ctnDelAll {
  padding-top: 20px;
  display: flex;
  justify-content: space-around;
}

.ctnLoadDelAll {
  padding-top: 20px;
  display: flex;
  font-size: 14px;
  gap: 20px;
  flex-direction: column;
  align-items: center;
}

.textModalBill {
  font-weight: bold;
  width: 95%;
  text-align: center;
}

.btnContentDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 33%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentWhiteDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 33%;
  height: 28px;
  position: relative;
  color: #006256;
  background: #eff0f0;
}

.btnContentConfirmedDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 43%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentConfirmedWhiteDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 43%;
  height: 28px;
  position: relative;
  color: #006256;
  background: #eff0f0;
}

.Arrows {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.Arrows:hover {
  background: whitesmoke;
}

.searchFilter {
  width: 110px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.custom-select {
  left: 4px;
  position: relative;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
}

.ContainerSearchInput {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: 0 20px 0 0;
  max-width: 100%;
}

.textRegister {
  font-weight: bold;
  padding-left: 20px;
}

.searchInput {
  display: flex;
  margin: 5px 0px 5px 0px;
}

.searchContainer {
  display: flex;
  gap: 10px;
  width: 80%;
  justify-content: flex-end;
  align-items: center;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(235 235 235);
  padding: 0 10px;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
}

.searchAll {
  justify-content: center;
  color: #006256;
  font-size: 13px;
  padding: 0rem 0.5rem;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 0 5px 5px 0;
  border-left: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
  width: 180px;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 0px;
  height: 30px;
  min-height: 30px;
  width: 30px;
  min-width: 30px;
  position: relative;
  background: whitesmoke;
  border-left: none;
  border-color: #e3e0e0;
  border-radius: 0;
  border-right: 1px solid #e3e0e0;
  border-bottom: 1px solid #e3e0e0;
  border-top: 1px solid #e3e0e0;
  color: #006256;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

.searchBtn:hover {
  background: rgb(205, 205, 205);
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
  position: absolute;
  right: 40px;
  top: 70px;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}

.generalContainer {
  background: white;
}

.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
}

.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 35px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 10%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 25px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}
.ContentTableModal {
  display: flex;
  flex-direction: column;
  padding: 10px 20px 0 20px;
  width: 100%;
}

tr:nth-child(even) {
  background: #f1f1f1;
}

td {
  text-transform: capitalize;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.FooterPagination {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 20px;
  width: 100%;
  justify-content: flex-end;
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  gap: 10px;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  cursor: auto;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalPurchase {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalPurchase:hover {
  background: whitesmoke;
  color: red;
}

.closeModalPurchase:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentNewAlertIcon {
  width: 25px;
  min-width: 25px;
  height: 25px;
  min-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 0 0 / 12%);
  border-radius: 8px;
}

.contentReportError {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  box-shadow: rgb(222, 222, 222) 0px 0px 3px 1px;
  padding: 0.5rem 0.5rem;
  gap: 0.5rem;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.rowModal {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.borderInput {
  font-size: 14px;
  height: 30px;
  border: none;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 15px;
  padding-right: 4px;
  color: #5c5855;
  background: #e8e8e8;
}

.borderInput:focus {
  border: none;
}

.input-group {
  width: 30%;
}

.input-group-supplier {
  width: 45%;
  position: relative;
}

.input-group-key {
  width: 100%;
  position: relative;
}

.user-label {
  position: absolute;
  left: 5px;
  font-size: 11px;
  z-index: 30;
  bottom: 23px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconCopy {
  position: absolute;
  right: 30px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: rgb(0, 0, 0);
  height: 30px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.form-control:focus {
  background-color: #ffffff00;
  box-shadow: none !important;
}

.form-control {
  border-radius: 0 !important;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.typeSale {
  color: #403b74;
  font-weight: bold;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .General {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }
  .ContainerBtn {
    width: 100%;
    padding: 0px;
    margin: 70px 0px 0px 8px;
  }
  .Btn {
    width: 33%;
    height: 30px;
    font-size: 11px;
  }
  .searchByMonth {
    width: 35%;
    margin: 10px 0px 10px 8px;
  }
  .month {
    font-size: 11px;
  }
  .lineSearch {
    padding: 0px;
  }
  .Summary {
    padding-bottom: 10px;
  }
  .ItemSummary {
    width: 32%;
    height: 50px;
    gap: 0px;
  }
  .searchAll {
    font-size: 11px;
    width: 70px;
  }
  .searchFilter {
    width: 100px;
  }
  .textRegister {
    margin: 10px 10px 0px 0px;
    padding-left: 0px;
  }
  .textRegister span {
    padding-left: 5px;
  }
  .searchInput {
    margin: 10px 10px 0px 0px;
  }
  .ContentTable {
    padding: 10px 10px 0 0px;
  }
  .inputSearch {
    width: 50%;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }
  .itemBtn {
    width: 18px;
    height: 18px;
  }
  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
  .FooterPagination {
    padding: 0px;
  }
}

@media screen and (max-width: 700px) {
  .General {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    width: 100% !important;
    height: 100vh;
    font-size: 10px;
  }

  .ContainerBtn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
    margin: 60px 0px 0px 0px;
  }

  .ContentTable {
    height: auto;
    padding: 10px 10px 0 10px;
  }

  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }

  .ContainerSearchInput {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    width: 100%;
    max-width: 100%;
    flex-direction: column;
  }

  .searchInput {
    display: flex;
    margin: 0px;
    width: 100%;
    flex-direction: column;
  }

  .Btn {
    width: 80%;
    height: 30px;
  }

  .searchByMonth {
    width: 80%;
    display: flex;
    align-items: center;
    margin: 10px 0px;
  }

  .lineSearch {
    display: flex;
    align-items: center;
    padding: 0px 0px 5px 0px;
    justify-content: center;
  }

  .ItemSummary {
    width: 32%;
    height: 80px;
    gap: 0px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
  }
}
</style>
